var path = '/app/components/deal-sheet/facebook-photo.component.html';
var html = "<img ng-if=\"$ctrl.facebookUserId\" ng-src=\"{{'https://graph.facebook.com/' + $ctrl.facebookUserId + '/picture?type=small'}}\"/>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;